import { IEvent } from '@generated/events';
import { isTesting } from '@lib/environment/isTesting';
import { logger } from '@lib/logger/logger';

import { getAmplitudeInstance } from './getAmplitudeInstance';
import { getEventProperties } from './getEventProperties';
import { isDatadogSynthetics } from './isDatadogSynthetics';

export function trackEvent(event: IEvent): void {
  const shouldTrackEvent = !isTesting() && !isDatadogSynthetics();
  const eventProperties = getEventProperties(event);

  logger.debug(eventProperties, `EVENT: ${event.name}`);

  if (shouldTrackEvent) {
    getAmplitudeInstance()?.logEvent(event.name, eventProperties);
  }
}
